export const AMPLITUDE_CONSTANTS = {};

export const AMPLITUDE_EVENTSOURCES = {
  groupAndpaydate_page: "group&paydate_page",
};
